
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import Paginator from "../../../common/paginator/Paginator";
import { ProfileEmpty, ProfileSection, ProfileSectionError } from "../common/ProfileSection";
import Publication from "./Publication";

export default function PublicationSection({ isDesktop, profileId }) {
	const [publications, setPublications] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchPublications();
	}, []);

	useEffect(() => {
		fetchPublications();
	}, [page]);

	function fetchPublications() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let pageParam = page ? page : 1;
		api.publicationListByProfile({
			profile_id: profileId,
			page: pageParam,
		})
			.then((result) => {
				setPublications(result["publications"]);
				setMaxPageNum(result["max_page"]);
				setIsLoading(false);
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	return (
		<ProfileSection title="مقالات">
			{publications.length >= 1 ? (
				<div className={`grid gap-4 ${isDesktop ? "grid-cols-3" : "grid-cols-1"}`}>
					{publications.map((publication) => (
						<Publication key={publication.id} publication={publication} />
					))}
				</div>
			) : (
				<ProfileEmpty>مقاله‌ای وجود ندارد</ProfileEmpty>
			)}
			{publications.length >= 1 && maxPageNum >= 2 && (
				<div className="flex justify-center mt-5">
					<Paginator
						currentPage={page}
						maxPageNum={maxPageNum}
						isLoading={isLoading}
						onChange={(newPage) => {
							setPage(newPage);
						}}
					/>
				</div>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
